module.exports = __webpack_public_path__ + "667f14f4510566294cebc99012c637ee.svg";